export const initialFS = {
  name: '/',
  type: 'dir',
  children: {
    home: {
      name: 'home',
      type: 'dir',
      children: {
        visitor: {
          name: 'visitor',
          type: 'dir',
          children: {

            '.secret_config': {
              name: '.secret_config',
              type: 'file',
              content: `PART 1: "sudo_"

Hint 2: The developer left important notes. Find and open the Notes app.`,
              size: 97,
              modified: '2025-11-15'
            },
            '.bashrc': {
              name: '.bashrc',
              type: 'file',
              content: `# ~/.bashrc: executed by bash(1) for non-login shells.
export PATH="/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin"
alias ll="ls -lah"
alias grep="grep --color=auto"`,
              size: 186,
              modified: '2025-11-10'
            },
            '.ssh': {
              name: '.ssh',
              type: 'dir',
              children: {},
              modified: '2025-11-01'
            },
            'Desktop': {
              name: 'Desktop',
              type: 'dir',
              children: {
                'resume.pdf': {
                  name: 'resume.pdf',
                  type: 'file',
                  content: `╔═══════════════════════════════════════════════════════════════════╗
║                    DIPTANSHU DHAWAN - RESUME                      ║
║                   Junior Penetration Tester                       ║
╚═══════════════════════════════════════════════════════════════════╝

📧 EMAIL     : tryhackme.com
🌐 LINKEDIN  : linkedin.com/in/diptanshudhawan
📺 YOUTUBE   : @diptanshu_dhawan
💻 GITHUB    : github.com/diptanshudhawan

───────────────────────────────────────────────────────────────────

🎓 EDUCATION

  B.Tech in Computer Science Engineering (2022-2026)
  Specialization: Cybersecurity
  Current GPA: [Your GPA]

───────────────────────────────────────────────────────────────────

🏆 CERTIFICATIONS

  ✓ eJPT (eLearnSecurity Junior Penetration Tester)
    Certified: December 2023
  
  ✓ TryHackMe - 150+ Rooms Solved
    Active Red Team & CTF Practitioner

───────────────────────────────────────────────────────────────────

💼 SKILLS

  Security Tools:
    → Metasploit | Hydra | Hashcat | ffuf | SQLMap
    → Nmap | Wireshark | Burp Suite | Netcat
  
  Programming:
    → Python | Bash | JavaScript | React
  
  Specializations:
    → Web Application Pentesting
    → Network Reconnaissance
    → Privilege Escalation
    → CTF Challenges

───────────────────────────────────────────────────────────────────

💡 Tip: Click the Resume icon on the desktop or dock for the 
        interactive version with download option!

═══════════════════════════════════════════════════════════════════`,
                  size: 2048,
                  modified: '2025-12-17'
                }
              },
              modified: '2025-12-17'
            },
            'Documents': {
              name: 'Documents',
              type: 'dir',
              children: {
                'about.txt': {
                  name: 'about.txt',
                  type: 'file',
                  content: 'I am a B.Tech CSE student passionate about Cybersecurity, Red Teaming, and CTFs.',
                  size: 85,
                  modified: '2025-11-20'
                },
                'projects.txt': {
                  name: 'projects.txt',
                  type: 'file',
                  content: '1. Portfolio (React)\\n2. Keylogger (Python)\\n3. Network Scanner (Bash)',
                  size: 72,
                  modified: '2025-11-22'
                },
                'notes.md': {
                  name: 'notes.md',
                  type: 'file',
                  content: `# Notes

📌 TODO - URGENT:
- Backup server logs  
- **Check robots.txt** - ensure sensitive paths are disallowed!
- Buy more coffee ☕ (critical!)
- Fix the auth bug in prod 🔧

💡 Reminder:
Don't forget to update the CTF challenges before deployment. The hidden files are in /home/visitor

✅ Completed:
- [x] Deploy portfolio v2.0
- [x] Implement resume viewer
- [x] Test all CTF stages 🔍`,
                  size: 356,
                  modified: '2025-12-12'
                },
                'resume.pdf': {
                  name: 'resume.pdf',
                  type: 'file',
                  content: '[PDF Document - Resume of Diptanshu Dhawan]',
                  size: 1024,
                  modified: '2025-11-25'
                }
              },
              modified: '2025-12-10'
            },
            'Downloads': {
              name: 'Downloads',
              type: 'dir',
              children: {
                'metasploit-latest.deb': {
                  name: 'metasploit-latest.deb',
                  type: 'file',
                  content: '[Debian Package]',
                  size: 52428800,
                  modified: '2025-12-01'
                },
                'wireshark-captures.pcap': {
                  name: 'wireshark-captures.pcap',
                  type: 'file',
                  content: '[Network Capture File]',
                  size: 8192000,
                  modified: '2025-12-05'
                }
              },
              modified: '2025-12-05'
            },
            'Pictures': {
              name: 'Pictures',
              type: 'dir',
              children: {
                'Screenshots': {
                  name: 'Screenshots',
                  type: 'dir',
                  children: {},
                  modified: '2025-11-15'
                }
              },
              modified: '2025-11-20'
            },
            'Videos': {
              name: 'Videos',
              type: 'dir',
              children: {},
              modified: '2025-11-18'
            },
            'Music': {
              name: 'Music',
              type: 'dir',
              children: {},
              modified: '2025-11-10'
            },
            'Public': {
              name: 'Public',
              type: 'dir',
              children: {},
              modified: '2025-11-01'
            },
            'Templates': {
              name: 'Templates',
              type: 'dir',
              children: {},
              modified: '2025-11-01'
            },
            'projects': {
              name: 'projects',
              type: 'dir',
              children: {
                'encrypted.txt': {
                  name: 'encrypted.txt',
                  type: 'file',
                  content: `🔐 ENCRYPTED MESSAGE - CTF PART 3 🔐

Encoded String: YWRtaW4=

💡 Hint: "Encryption" and "encoding" are NOT the same thing.
One protects secrets, the other just... rearranges them. 😏

🛠️  Decode this using "Diptanshu's SwissArmy" from Applications!`,
                  size: 256,
                  modified: '2025-11-26'
                }
              },
              modified: '2025-11-26'
            }
          }
        }
      }
    },
    bin: {
      name: 'bin',
      type: 'dir',
      children: {
        'ls': { name: 'ls', type: 'file', content: '[executable]' },
        'cat': { name: 'cat', type: 'file', content: '[executable]' },
        'bash': { name: 'bash', type: 'file', content: '[executable]' },
        'python3': { name: 'python3', type: 'file', content: '[executable]' }
      }
    },
    usr: {
      name: 'usr',
      type: 'dir',
      children: {
        'bin': {
          name: 'bin',
          type: 'dir',
          children: {
            'python': { name: 'python', type: 'file', content: '[executable]' },
            'python3': { name: 'python3', type: 'file', content: '[executable]' },
            'node': { name: 'node', type: 'file', content: '[executable]' },
            'npm': { name: 'npm', type: 'file', content: '[executable]' }
          }
        },
        'share': { name: 'share', type: 'dir', children: {} },
        'local': {
          name: 'local',
          type: 'dir',
          children: {
            'bin': { name: 'bin', type: 'dir', children: {} }
          }
        }
      }
    },
    var: {
      name: 'var',
      type: 'dir',
      children: {
        'log': {
          name: 'log',
          type: 'dir',
          children: {
            'syslog': { name: 'syslog', type: 'file', restricted: true, content: 'Permission denied' },
            'auth.log': { name: 'auth.log', type: 'file', restricted: true, content: 'Permission denied' }
          }
        },
        'tmp': { name: 'tmp', type: 'dir', children: {} }
      }
    },
    etc: {
      name: 'etc',
      type: 'dir',
      children: {
        'shadow': {
          name: 'shadow',
          type: 'file',
          restricted: true,
          content: 'Permission denied. Nice try though! 😏'
        },
        'passwd': {
          name: 'passwd',
          type: 'file',
          content: 'root:x:0:0:root:/root:/bin/bash\\nvisitor:x:1000:1000:visitor:/home/visitor:/bin/bash'
        },
        'hostname': {
          name: 'hostname',
          type: 'file',
          content: 'parrot-os'
        },
        'os-release': {
          name: 'os-release',
          type: 'file',
          content: 'NAME="Parrot OS"\\nVERSION="5.1"\\nID=parrot\\nID_LIKE=debian\\nPRETTY_NAME="Parrot OS 5.1"'
        }
      }
    },
    tmp: { name: 'tmp', type: 'dir', children: {} },
    root: { name: 'root', type: 'dir', children: {} },
    opt: { name: 'opt', type: 'dir', children: {} },
    lib: { name: 'lib', type: 'dir', children: {} },
    dev: { name: 'dev', type: 'dir', children: { 'null': { name: 'null', type: 'file', content: '' }, 'zero': { name: 'zero', type: 'file', content: '' } } },
    proc: { name: 'proc', type: 'dir', children: {} },
    sys: { name: 'sys', type: 'dir', children: {} }
  }
};
